import { getEnvValue } from '../../Helper/env';
import { MaybePromise } from '@reduxjs/toolkit/dist/query/tsHelpers';

import UrlParameterHelper from '../../Helper/UrlParameter';

const RAZZLE_BUILD_MODE = getEnvValue('RAZZLE_BUILD_MODE');
const isBranded = RAZZLE_BUILD_MODE === 'branded';

type ConditionalUrlAndHeaders = {
  url: string;
  urlBranded: string;
  headers: Headers | { 'x-api-version': string };
};
export const getConditionalUrlAndHeaders = ({
  url,
  urlBranded,
  headers,
}: ConditionalUrlAndHeaders) => {
  const cpyHeaders = { ...headers }; // shallow copy to avoid mutating the original object
  if (isBranded) delete cpyHeaders['x-api-version']; // Remove 'x-api-version' if the request is branded
  return {
    url: isBranded ? urlBranded : url,
    headers: cpyHeaders as Headers,
  };
};

export const queryFnRequest = async <T>(
  baseQuery: (arg: any) => MaybePromise<any>,
  requestParams: any,
) => {
  try {
    const result = await baseQuery(requestParams);
    if ('error' in result) return { error: result.error };
    return { data: result.data as T };
  } catch (error) {
    return { error: error.message };
  }
};

export const serializeParams = (params: { [key: string]: any }) => {
  const plainObj = {}; // { key: string }
  const arrayObj = {}; // { key: [string, string] }
  Object.keys(params).forEach((p) => {
    const val = params[p];
    if (Array.isArray(val)) {
      arrayObj[p] = val;
    } else {
      plainObj[p] = val;
    }
  });
  return UrlParameterHelper.buildQueryString(plainObj, arrayObj);
};
